<template>
  <div id="app">
    <Header v-if="!screen"></Header>
    <router-view/>
    <Footer v-if="!screen"></Footer>
    <GoTop v-if="!screen"></GoTop>
  </div>
</template>

<script>
import store from "./store";
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'screen'
    ])
  },
  mounted() {
    console.log('当前发布版本时间', '2026-04-09 00:30')
  }
}
</script>

<style scoped>
  #app {
    display: flex;
    flex-direction: column;
    height: 100vh; /* 设置容器高度为视口高度 */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue